export const libUtilMixin = {
  methods: {
    nbMonnaie(item) {
      return typeof item === "number"
        ? item
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            .replace(".", ",") + " €"
        : item;
    },
    arrondi2(item) {
      return typeof item === "number" ? Math.round(item * 100) / 100 : item;
    },
  },
};
